const translations = {
  eng: [
  ],
  slv: [
  ]
};

export function t(v: string, variant?: number, ...args: string[]) {
  const trans = (translations['eng'] ?? [{}]);
  // @ts-ignore
  let result: string = (trans[variant ?? 0] ?? {})[v] ?? (trans[0] ?? {})[v] ?? v;
  for (const replacement of args) {
    result = result.replace('%s', replacement);
  }
  return result;
}

export function tr(v: string, ...args: string[]) {
  const trans = (translations['eng'] ?? [{}]);
  // @ts-ignore
  let result: string = (trans[0] ?? {})[v] ?? (trans[0] ?? {})[v] ?? v;
  for (const replacement of args) {
    result = result.replace('%s', replacement);
  }
  return result;
}
